/**
 * Header Component
 * 
 * This component renders the application header with title,
 * user info, language toggle, and logout functionality.
 */

import React from 'react';
import { useApp } from '../../context/AppContext';
import { useTranslations } from '../../context/TranslationsContext';

const Header = () => {
  const { state, actions } = useApp();
  const { translations } = useTranslations();
  const t = translations[state.currentLanguage];

  return (
    <header className="app-header">
      <h1 className="app-title">{t.title}</h1>
      <div className="header-actions">
        {state.isAuthenticated && (
          <span className="user-info">مرحباً {state.user?.username}</span>
        )}
        <button 
          onClick={() => actions.setLanguage(state.currentLanguage === 'ar' ? 'en' : 'ar')}
          className="language-toggle"
        >
          {state.currentLanguage === 'ar' ? 'EN' : 'AR'}
        </button>
        {state.isAuthenticated && (
          <button onClick={actions.logout} className="logout-btn">
            {t.logout}
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
